import React, { Component } from 'react'
import { Input, Radio } from 'antd'

import VendorAddressForm from '../components/VendorAddressForm'
const { TextArea } = Input
const RadioButton = Radio.Button
const RadioGroup = Radio.Group

class VendorPurchaseOrderBasicInfo extends Component {
  state = {}

  renderSelectedShipping = () => {
    const { basicInfoInputChange, setVendorAdressForm } = this.props
    const isOtherShippingOption = this.props.shipTo === '4'
    let content = (
      <div>
        <div>{'Attention to '}</div>
        <Input
          placeholder="Type in a name..."
          onChange={event => basicInfoInputChange(event.target.value, 'basicInfoAttention')}
          value={this.props.attention}
        />
      </div>
    )
    //shipping_address
    if (isOtherShippingOption) {
      content = (
        <VendorAddressForm
          wrappedComponentRef={setVendorAdressForm}
          contentData={this.state.addressData}
        />
      )
    }
    return (
      <div className="col-md-6">
        <h5>Ship To</h5>
        Location
        <div>
          <RadioGroup
            value={this.props.shipTo}
            onChange={event => basicInfoInputChange(event.target.value, 'basicInfoShipTo')}
          >
            <RadioButton value="1">G-Tech</RadioButton>
            <RadioButton value="2">Jobsite</RadioButton>
            <RadioButton value="3">Client</RadioButton>
            <RadioButton value="4">Other</RadioButton>
          </RadioGroup>
        </div>
        {content}
      </div>
    )
  }
  render() {
    const { basicInfoInputChange } = this.props

    return (
      <div>
        <div className="row">
          <div className="col-md-6">
            <h5>General Info</h5>
            Description
            <TextArea
              placeholder="Describe the order..."
              rows={4}
              onChange={event => basicInfoInputChange(event.target.value, 'basicInfoDescription')}
              value={this.props.description}
            />
            Terms
            <TextArea
              placeholder="Type in the terms..."
              rows={4}
              onChange={event => basicInfoInputChange(event.target.value, 'basicInfoTerms')}
              value={this.props.terms}
            />
          </div>
          {this.renderSelectedShipping()}
        </div>
      </div>
    )
  }
}

export default VendorPurchaseOrderBasicInfo



// WEBPACK FOOTER //
// ./src/components/VendorPurchaseOrderBasicInfo.js